// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivateRoute_container__2E4LQ","containerWithoutMenu":"PrivateRoute_containerWithoutMenu__nuVA0"};